import React, { useState, useRef, useContext } from 'react';
import useOutsideElement from 'components/Dashboard/utilities/useOutsideElement';
import { SaveButton, ShareContent } from './Share';
import preventLink from 'components/Dashboard/TagsList/prevenLink';
import { useLocation } from 'react-router';
import useIsMobile from 'components/Dashboard/utilities/useIsMobile';
import { store } from 'components/Store';
import { Portal } from 'react-portal';

const ItemActionsComponent = (props) => {
  const {
    item,
    listItem,
    alreadyInContacts,
    stakeholderMapping,
    setContactIdsCheck,
    contactIdsCheck,
    influenceItem,
    setShowStakeholdersCrmPopup,
    index,
    itemActionsProps,
    hideActions,
    setShowActions,
    reportButtonElement,
    dispatch,
  } = props;
  const { onlyDots, noAddToReportButton } = itemActionsProps ?? {};
  return (
    <div className='box box-shadow py-2 item-actions-box item-actions-box-normal-spacing'>
      <ShareContent
        item={item}
        id={item.id}
        title={item.title}
        url={item.contentUrl}
        embargoed={item.embargoed}
        listItem={listItem}
        itemShare
        influenceItem={influenceItem}
        alreadyInContacts={alreadyInContacts}
        stakeholderMapping={stakeholderMapping}
        setContactIdsCheck={setContactIdsCheck}
        contactIdsCheck={contactIdsCheck}
        setShowStakeholdersCrmPopup={setShowStakeholdersCrmPopup}
        hideActions={hideActions}
        setShowActions={setShowActions}
        index={index}
      />

      {onlyDots && (
        <>
          {!noAddToReportButton && (
            <button
              className='d-flex align-items-center button-create-report general-button light-50-text'
              data-tooltip-content={
                item?.embargoed ? 'You cannot add this update to a report while it is under embargo' : ``
              }
              ref={reportButtonElement}
              data-tooltip-id='general-tooltip'
              onClick={(e) => {
                reportButtonElement?.current?.blur();
                preventLink(e);
                dispatch({
                  type: 'MODIFY_SECTION',
                  parameter: 'createReportFromUpdatePopup',
                  value: {
                    open: true,
                    update: item,
                  },
                });
              }}
              disabled={item?.embargoed}
            >
              <span className='icon-document specific-left-padding-3 specific-right-margin-13' />
              Add to a report
            </button>
          )}
          <div className='specific-left-padding-1'>
            <SaveButton {...props} hideActions={hideActions} immediateLoad={true} showText={true} />
          </div>
        </>
      )}
    </div>
  );
};

const ItemActions = (props) => {
  const { item, listItem, itemActionsProps } = props;
  const { onlyDots, fixedPosition, noDots } = itemActionsProps ?? {};

  const globalState = useContext(store);
  const { dispatch } = globalState;

  const [showActions, setShowActions] = useState(false);
  const actionsElement = useRef(null);
  const location = useLocation();
  const hideActions = () => {
    setShowActions(false);
  };
  useOutsideElement(actionsElement, hideActions);

  const embedWidget = location.pathname.toLowerCase().startsWith('/embed');
  const showItemActions = !embedWidget || (embedWidget && !listItem);
  const isMobile = useIsMobile();

  const reportButtonElement = useRef(null);

  const { top, left } = actionsElement.current?.getBoundingClientRect() ?? {};

  return (
    <div
      ref={actionsElement}
      className='item-actions-container item-actions-container-current-content position-relative'
    >
      <div className='flex-centered'>
        {!embedWidget && !onlyDots && (!listItem || (listItem && !isMobile)) && (
          <SaveButton {...props} hideActions={hideActions} />
        )}
        {showItemActions && !noDots && (
          <button
            className={`general-button circle-button circle-btn-with-hover ${showActions ? 'active' : ''}`}
            onClick={(e) => {
              preventLink(e);
              setShowActions(!showActions);
            }}
            style={{ visibility: item.type === 'Event' ? 'hidden' : 'visible' }} //AE: Better having visibility hidden to keep the space and the alignment of the save icon with the other items on /saved-items
          >
            {/* Item actions */}
            <span
              className='icon-three-dots title-h4 d-block'
              style={{
                color: 'rgba(0, 18, 43, 0.5)',
                marginTop: '0px',
                marginLeft: '-1px',
              }}
            ></span>
          </button>
        )}
      </div>
      {showActions && (
        <>
          {fixedPosition ? (
            <Portal node={document && document.querySelector('body')}>
              <div className='general-close-background z-max' onClick={() => setShowActions(false)} />
              <div
                className='z-extra-max'
                style={{ position: 'fixed', top: `${top}px`, left: `${left}px`, width: '200px' }}
                onClick={(e) => {
                  preventLink(e);
                }}
              >
                <ItemActionsComponent
                  {...props}
                  hideActions={hideActions}
                  setShowActions={setShowActions}
                  reportButtonElement={reportButtonElement}
                  dispatch={dispatch}
                  isMobile={isMobile}
                />
              </div>
            </Portal>
          ) : (
            <ItemActionsComponent
              {...props}
              hideActions={hideActions}
              setShowActions={setShowActions}
              reportButtonElement={reportButtonElement}
              dispatch={dispatch}
              isMobile={isMobile}
            />
          )}
        </>
      )}
    </div>
  );
};

export default ItemActions;
